// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"882f1bc1","382":"882f1bc1"}[chunkId] + ".chunk.css";
};